import { Reducer } from 'redux';
import { UserAction } from '../actions';
import { ActionType } from '../constants/ActionType';

/**
 * We derive UserState from the current URL path.
 *
 * When a community member visits community routes, e.g. /app, /app/1, /app/2/feed
 * - currentCommunityId is not null.
 * - currentAccountId is null.
 * When a vendor visits vendorlink routes, e.g. /vendor, /vendor/1, /vendor/2/getPaid
 * - currentAccountId is not null.
 * - currentCommunityId is null.
 *
 * If a user does not belong to any communities or vendorlink accounts
 * - currentAccountId is null.
 * - currentCommunityId is null.
 */
export interface UserState {
  currentCommunityId?: number;
  currentAccountId?: number;
}

export const User: Reducer<UserState> = (state: UserState = {}, action: UserAction): UserState => {
  switch (action.type) {
    case ActionType.SET_CURRENT_COMMUNITY_ID:
      return {
        ...state,
        currentCommunityId: action.communityId,
        // Community routes and vendor link routes are mutually exclusive.
        currentAccountId: undefined,
      };
    case ActionType.SET_CURRENT_ACCOUNT_ID:
      return {
        ...state,
        currentAccountId: action.accountId,
        // Community routes and vendor link routes are mutually exclusive.
        currentCommunityId: undefined,
      };
    case ActionType.CLEAR_CURRENT_COMMUNITY_ID:
    case ActionType.CLEAR_CURRENT_ACCOUNT_ID:
      return {
        ...state,
        currentAccountId: undefined,
        currentCommunityId: undefined,
      };
    case ActionType.SIGNOUT:
      return {};
    default:
      return state;
  }
};
